import type { ConfiguratorPoolStair } from './configuratorPoolStair.model'
import { z } from 'zod'
import { directusImageDtoSchema, transformDirectusImageDtoToDirectusImage } from '../directus/directusImageDto.model'
import { directusNameTranslationDtoSchema, transformDirectusNameTranslationDtoToDirectusNameTranslation } from '../directus/directusNameTranslationDto.model'

export const configuratorPoolStairDtoSchema = z.object({
  id: z.number(),
  translations: z.array(directusNameTranslationDtoSchema),
  stair_image: directusImageDtoSchema,
})

export type ConfiguratorPoolStairDto = z.infer<typeof configuratorPoolStairDtoSchema>

export function transformConfiguratorPoolStairDtoToConfiguratorPoolStair(configuratorPoolStairDto: ConfiguratorPoolStairDto): ConfiguratorPoolStair {
  return {
    id: configuratorPoolStairDto.id,
    translations: configuratorPoolStairDto.translations.map(directusNameTranslationDto => transformDirectusNameTranslationDtoToDirectusNameTranslation(directusNameTranslationDto)),
    stairImage: transformDirectusImageDtoToDirectusImage(configuratorPoolStairDto.stair_image),
  }
}
